import { styled, SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Defines two color variants for nav icons: primary (active) and secondary (inactive).
 * The child svg definition should use 'currentColor' for stroke and fill, and 'var(--nav-icon-fill-opacity, 0)' for fillOpacity.
 */
export const NavIcon = styled(SvgIcon)<SvgIconProps>(({ theme }) => ({
  color: theme.vars.palette.text.secondary,
  variants: [
    {
      // Active color with background fill
      props: ({ color }) => color === 'primary',
      style: {
        '--nav-icon-fill-opacity': 0.2,
        color: theme.vars.palette.primary.main,
      },
    },
    {
      props: ({ color }) => color === 'secondary',
      style: {
        // Unselected color with no background fill
        '--nav-icon-fill-opacity': 0,
        color: theme.vars.palette.text.secondary,
      },
    },
  ],
}));
